const r = {
  root: "StennProgressBar-root",
  wrapper: "StennProgressBar-wrapper"
}, s = {
  root: "StennProgressBarContainer-root"
}, o = {
  root: "StennProgressBarLabel-root"
}, e = {
  root: "StennProgressBarValue-root"
}, n = {
  root: "StennProgressBarDescription-root",
  description: "StennProgressBarDescription-description",
  icon: "StennProgressBarDescription-icon"
};
export {
  r as progressBarClasses,
  s as progressBarContainerClasses,
  n as progressBarDescriptionClasses,
  o as progressBarLabelClasses,
  e as progressBarValueClasses
};
//# sourceMappingURL=constants4.mjs.map
